import React from "react";
import PolicyPage from "./PolicyPage";
import { policyDocuments } from "../Datas/policyData";

function Terms() {
  return <PolicyPage document={policyDocuments.terms} />;
}

export default Terms;
